import type { NextApiRequest, NextApiResponse } from 'next';
import { get } from 'lodash';

import { getSession } from '../../services/session.service';
import { filterQuoteFieldsByVertical } from '../../../../common/utils/filter-quote-fields-by-vertical.util';
import { Config, Session, Vertical } from '@bolttech/essentials'
import {
  quoteService
} from '../../../quotes';
import {
  loggerService,
} from '../../../../common/services/logger';

import { Quote } from '../../../../common/interface/quote.interface';

export const config = {
  api: {
    externalResolver: true,
  },
};


export async function parseSession(
  req: NextApiRequest,
  session: Session,
  locale?: string,
  vertical?: string,
  query?: Record<string, string>,
): Promise<Session> {
  session.cookie.originalMaxAge = 259200000;
  session.cookie.expires = new Date();
  session.cookie.expires.setMilliseconds(
    session.cookie.expires.getMilliseconds() + session.cookie.originalMaxAge,
  );
  session.locale = locale;

  session.ip =
    get(req, 'headers.x-original-forwarded-for') ||
    get(req, 'headers.x-forwarded-for') ||
    get(req, 'connection.remoteAddress') ||
    get(req, 'socket.remoteAddress') ||
    get(req, 'connection.socket.remoteAddress');

  session.ip = session.ip.split(',').pop();
  session.ip = session.ip.split(':').slice(-1).pop();
  session.ip = session.ip.trim();

  const { h, x } = query as Record<string, string>;
  session.quote = {} as Quote;

  if (h && x) {
    try {
      const quote = await quoteService.getQuoteByHash(h, x);

      if (quote) {
        session.quoteId = quote.quoteId;
        session.quote = quote;
      }
    } catch (error) {
      loggerService.error(`parseSession api/session`, error);
    }
  }

  session.filteredQuoteData = filterQuoteFieldsByVertical(
    session.quote,
    vertical as Vertical,
  );

  session.loggedInStatus = get(session, 'cla') ? true : false;

  session.userInitials = ((): string => {
    const customer = get(session, 'cla.customer');
    return customer
      ? `${
          customer.firstName
            ? customer.firstName.trim().charAt(0).toLocaleUpperCase()
            : ''
        }
        ${
          customer.lastName
            ? customer.lastName.trim().charAt(0).toLocaleUpperCase()
            : ''
        }`
      : '';
  })();

  session.commit();

  return session;
}

async function handler(
  req: NextApiRequest,
  res: NextApiResponse,
): Promise<void> {
  const { locale, vertical, query }: Config = get(req, 'body');
  const session = await getSession(req, res);

  const parsedSession = parseSession(req, session, locale, vertical, query);

  return res.status(200).send(parsedSession);
}

handler.$methods = ['POST'];
handler.$statusCode = 200;

export default handler;
